import { Box, styled, Typography, Chip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { OptionButton, OptionButtonType } from '../../../../components/Button/OptionButton';
import { dimensions } from '../../../../styles/dimensions';
import { theme } from '../../../../styles/theme';
import { Processor } from '../../../../models/processor';

interface HeaderProcessorInformationProps {
  processor: Processor;
}

export const HeaderProcessorInformation: React.FunctionComponent<HeaderProcessorInformationProps> = ({ processor }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate('edit');
  };

  return (
    <Wrapper>
      <TitleWrapper>
        <TitleInfoWrapper>
          <Typography variant="h5" component="h2">
            {processor.proName}
          </Typography>
          <Chip
            label={processor.proIsOnline ? t('processor.status.online') : t('processor.status.offline')}
            color={processor.proIsOnline ? 'success' : 'error'}
            size="small"
          />
        </TitleInfoWrapper>
      </TitleWrapper>

      <ButtonWrapper>
        <OptionButton type={OptionButtonType.EDIT} content={t('edit')} onClick={handleEdit} isscaledown={false} />
      </ButtonWrapper>
    </Wrapper>
  );
};

const { baseLG, baseMD, base, buttonHeight } = dimensions;
const { grey } = theme.palette;

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 ${baseLG};
  padding: ${baseMD} 0;
  border-bottom: 1px solid ${theme.palette.grey[400]};
`;

const TitleWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const TitleInfoWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${baseMD};
`;

const ButtonWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  flex-flow: row wrap;
  column-gap: ${base};
  row-gap: ${base};
  height: ${buttonHeight};
`;
